import {html, type TemplateResult} from "lit";
import {customElement, property, state} from "lit/decorators.js";
import {ChapterData, chapterLinkEvent} from "./chapters";
import {UnLitElement} from "../../../common/elements";
import {trackingTextlinkInteract} from "../../../tracking/trackingAttributes";

@customElement("eop-chapter-link")
export class EopChapterLink extends UnLitElement {

    @state()
    private item: ChapterData;
    @property()
    private highlight: boolean;

    public render(): TemplateResult {
        return html`
            <div class="chapter-link">
                <a class="link"
                   href=${this.item.href}
                   ?active=${this.highlight && this.item.active}
                   @click=${this.handleClick}
                   ${trackingTextlinkInteract(this.item.name, this.item.href)}
                >${this.item.name}</a>
            </div>
        `;
    }

    private handleClick(event: Event): void {
        event.preventDefault();
        this.dispatchEvent(chapterLinkEvent(this.item));
    }
}